export default __webpack_public_path__ + "static/media/uyafi-min.eecfeee3.png";